import { Skeleton } from "components/Skeleton";
import React from "react";
import * as styles from "./RaceInfoSkeleton.module.scss";

export default () => <Skeleton className={styles.raceInfo} size="sm" />;
